import React, { useEffect } from "react";
import classes from "../Login.module.scss";
import RoundedButton from "../../Buttons/RoundedButton/RoundedButton";
import TagInput from "../../UI/Inputs/TagInput";
import TagInputFake from "../../UI/Inputs/TagInputFake";
import H1 from "../../UI/Titles/H1/h1";
import { useTranslation } from "react-i18next";
import InfosPasswordLabels from "../../InfosLabels/InfosPasswordLabels";
import InfoLabel from "../../InfosLabels/InfoLabel";

const UpdatePWForm = ({
  login = {},
  errorMsg = null,
  formSubmit = () => {},
  onChange = () => {},
  bottomLink = () => {},
}) => {
  const { t } = useTranslation();

  //Scroll to top when start
  useEffect(() => window.scrollTo(0, 200), []);

  return (
    <>
      <form className={classes.Form} onSubmit={(event) => formSubmit(event)}>
        <H1 className={classes.Title}>{t("global.update_password")}</H1>
        {errorMsg && <div className={classes.ErrorMsg}>{t(errorMsg)}</div>}
        {/* <p className={classes.Input}>{login.username}</p> */}

        <TagInputFake
          disable
          className={classes.Input}
          value={login.username}
          label={t("global.email")}
        />

        <TagInput
          type="text"
          name="verify_codigo"
          className={classes.Input}
          placeholder={t("global.eg") + " 00000..."}
          value={login.verify_codigo}
          onChange={onChange}
          label={t("global.verify_code")}
          required
        />
        <InfoLabel text={t("login.verification_code_send")} />
        <TagInput
          type="password"
          name="password"
          label={t("global.new_password")}
          className={classes.Input}
          placeholder={t("global.new_password")}
          value={login.password}
          onChange={onChange}
          required
        />
        <InfosPasswordLabels />

        <RoundedButton
          className={classes.BtnEnter}
          type="submit"
          text={t("global.update")}
        />
        <button
          tabIndex="0"
          className={classes.TextInfo + " link"}
          onClick={() => bottomLink()}
        >
          {t("global.back_to_login")}
        </button>
      </form>
    </>
  );
};

export default UpdatePWForm;
